import { render, staticRenderFns } from "./BetLimitSettings.vue?vue&type=template&id=73331b24"
import script from "./BetLimitSettings.vue?vue&type=script&lang=js"
export * from "./BetLimitSettings.vue?vue&type=script&lang=js"
import style0 from "./BetLimitSettings.vue?vue&type=style&index=0&id=73331b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports